export default [
  {
    id: '15FDDBC4667',
    accept: true,
    de: "Gesetzliche Versicherung",
    en: "Statutory dental insurance"
  },
  {
    id: '15630218EEB',
    accept: true,
    de: "Private Versicherung",
    en: "Private dental insurance"
  },
  {
    id: '15630217242',
    accept: true,
    de: "Keine Zahnversicherung / Selbstzahler",
    en: "No insurance / self-pay"
  }
]
